export default "__VITE_ASSET__KC1Q85EG__"